import React, { useEffect, useState } from "react";
import DocumentGallery from "./DocumentGallery";
import InputField from "@src/common/InputField";
import ReactSelect from "@src/common/ReactSelect";
import FullPageLoader from "@src/common/FullPageLoader";
import LeadRemarksButton from "../common/LeadRemarksButton";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { fetchLeadData, savePartnerPayment, updateLeadDetailsInStore } from "@src/store/slices/insurance";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { COUNTRY_CODE, ROLE_FEATURES, STATUS_SUCCESS } from "@src/config/constant";
import * as HELPER from "../../../config/helper";
import { useLanguage } from "@src/context/LanguageContext";
import InsuranceService from 'services/InsuranceService';
import _ from "lodash";
import { VEHICLE_USAGE_ID } from "@src/config/id/constant";
import moment from 'moment';

export default function InsurerPartnerPayment(props: any) {
    let { formType } = props
    const [loading, setLoading] = useState(false)
    const [disableBtn, setDisableBtn] = useState(false)
    let insuranceState: any = useSelector((state: any) => state.insurance)
    const {translations} = useLanguage();
    const dispatch: any = useDispatch()
    const queryParams: any = useParams()
    const [afterSaveBtn, setAfterSaveBtn] = useState(true) 
    
    const [formValues, setFormValues] = useState<any>({});
    // eslint-disable-next-line
    let allStatus = insuranceState?.leadDetail?.prev_status_sub_status_ids

    const debouncedCalculateInsurance =_.debounce((trnasFee) => {
        calculateInsuranceID(trnasFee); 
    }, 1000)

    // const dynamicFields = ['transaction_fee']
    const isFieldDisabled = (key: any) => {
        if (['transaction_fee'].includes(key)) {
            return false
        }

        return true
    }

    const shouldShowField = (key: any) => {
        return true
    }

    // const getFieldItemValue = (field: any) => {
    //     let { key } = field
    //     //let value = (key =="total_invoice") ?  +insuranceState?.leadDetail?.admin_fee + +insuranceState?.leadDetail?.final_premium - +insuranceState?.leadDetail?.transaction_fee : insuranceState?.leadDetail?.[key]
    //     let value = (key =="total_invoice") ? insuranceState?.leadDetail?.[key]  : insuranceState?.leadDetail?.[key];
    //     return (dynamicFields.includes(key) && field?.value) ? field?.value : value;

    // }

    const getFieldItemValue = () => {
        let initialValues: any = {};
        formFields.forEach((field: any) => {
            let { key } = field;
            //initialValues[key] = (key =="insurance_partner") ? insuranceState?.leadDetail?.[key] : HELPER.addCurrencyFormatting(insuranceState?.leadDetail?.[key]);
            // initialValues[key] = (key ==="insurance_partner") ? insuranceState?.leadDetail?.[key] : insuranceState?.leadDetail?.[key] ? HELPER.addCurrencyFormatting(insuranceState?.leadDetail?.[key]) : '0';
            initialValues[key] = insuranceState?.leadDetail?.[key] ?? '0'; 
        });
        return initialValues;
    };

    useEffect(() => {
        setFormValues(getFieldItemValue());
        // eslint-disable-next-line
    }, [insuranceState?.leadDetail]); 

    const getFieldItemOptions = (field: any) => {
        return []
    }

    // const handleChange = (field: any, value: any) => {
    //     let updatedValue = value?.target?.value
    //     field['value'] = updatedValue; 
    //     if(field['key'] == 'transaction_fee' && updatedValue){
    //         debouncedCalculateInsurance(updatedValue); 
    //     }

    //     setDisableBtn(true)
    // }

    const handleChange = (key: string, value: string) => {
        setFormValues((prevValues: any) => ({
            ...prevValues,
            [key]: value,
        }));
        if(key === 'transaction_fee' && value){
            debouncedCalculateInsurance(value); 
        }
        setDisableBtn(true)
    };

    // const handleBlurChange =  (field: any, value: any) => {
    //     let changeValue = value?.target?.value
    //     field['value'] = changeValue;
    //     if(field['key'] == 'transaction_fee' && changeValue){
    //         debouncedCalculateInsurance(changeValue);

    //     }
    // }


    const calculateInsuranceID = async(transactionFee: any) =>{
        const InsuranceObj:Record<string, any> = {
            sort_by: 'RC',
            insurer_id: insuranceState?.leadDetail?.insurer_id,
            insurance_type: insuranceState?.leadDetail?.insurance_type_id,
            vehicle_type: insuranceState?.leadDetail?.vehicle_type,
            plate_area_type: insuranceState?.leadDetail?.plate_number_region || 1, 
            make: insuranceState?.leadDetail?.make,
            make_year: insuranceState?.leadDetail?.make_year,
            addon_detail: insuranceState?.leadDetail?.addon_detail,
            customer_discount: insuranceState?.leadDetail?.customer_discount,
            customer_discount_per: insuranceState?.leadDetail?.customer_discount_per,
            car_fmv: insuranceState?.leadDetail?.car_fmv,
            total_fmv: insuranceState?.leadDetail?.total_fmv,
            transaction_fee: +transactionFee,
            vehicle_condition:insuranceState?.leadDetail.vehicle_condition_id,
            vehicle_usage:VEHICLE_USAGE_ID[insuranceState?.leadDetail?.vehicle_usage],
            rule_engine:insuranceState?.leadDetail?.rule_engine_id, 
            insurance_starting_date: moment(insuranceState?.leadDetail?.insurance_start_date).format('YYYY-MM-DD'),
        };
        delete InsuranceObj.insurance_type;  
        InsuranceObj.tenure = insuranceState?.leadDetail?.tenure;
        InsuranceObj.multi_year = insuranceState?.leadDetail?.lead_tenure_data?.map((row:any)=>{
            return {
                insurance_type: row.insurance_type_id,
            }
        })
       
        let result = await InsuranceService.getAddonDetailsID(InsuranceObj);
        setDisableBtn(false)
        if (result?.status === STATUS_SUCCESS && result?.data?.data) {
            let { quotation } = result?.data?.data
            // setTransactionFee(transactionFee);
            // setTimeout(() => {
            //     dispatch(updateLeadDetailsInStore({ ...insuranceState?.leadDetail, total_invoice: quotation?.[0]?.total_invoice,oto_to_partner: quotation?.[0]?.oto_to_partner }));
            // },500)
            setFormValues((prevValues: any) => ({
                ...prevValues,
                total_invoice: quotation?.[0]?.total_invoice || 0,
                oto_to_partner: quotation?.[0]?.oto_to_partner || 0,
            }));
       
        } else {
            console.log(result?.data?.message);
        }
    }

    const submitHandler = async () => {
        
        //const transactionFee = formFields?.find((e: any) => e.key === 'transaction_fee')?.value;
        //const totalInvoice = formFields?.find((e: any) => e.key === 'total_invoice')?.value;
        //const transactionFee = insuranceState?.leadDetail?.transaction_fee;
        //const totalInvoice = insuranceState?.leadDetail?.total_invoice;
        //const otoToPartner = insuranceState?.leadDetail?.oto_to_partner;
        const transactionFee = +formValues?.transaction_fee;
        const totalInvoice = formValues?.total_invoice;
        const otoToPartner = formValues?.oto_to_partner;
        if (!transactionFee || !totalInvoice) {
            if(transactionFee && !totalInvoice) {
                return toast.error("Please wait for updated Invoice amount");
            }
            return toast.error("Please enter transaction fee");
        }
        setLoading(true);
        //dispatch(savePartnerPayment({ leadId: queryParams.id, transaction_fee: +formFields?.find((e: any) => e.key === 'transaction_fee')?.value, total_invoice: +formFields?.find((e: any) => e.key === 'total_invoice')?.value })).then((res: any) => {
        dispatch(savePartnerPayment({ 
            leadId: queryParams.id,
            transaction_fee: transactionFee,
            total_invoice: totalInvoice,
            oto_to_partner: otoToPartner
         })).then((res: any) => {
            if (res && res.status === STATUS_SUCCESS) {
                toast.success(res.message)
                if (res.data) {
                    setAfterSaveBtn(false); 
                    //dispatch(updateLeadDetailsInStore({ ...insuranceState?.leadDetail, ...res.data }))
                }
            }
            setLoading(false)
        }).finally(() => { setLoading(false) })

    }

    const renderFieldComponent = (field: any) => {
        const { key, type, classname, maxLength, placeholder } = field;
        const disabled = field.hidden();
        const isCurrencyKey = COUNTRY_CODE === 'id' && key !== 'insurance_partner';
        return (

            ['text', 'number'].includes(type) ?
                <fieldset className={classname} key={key}>
                    <div className="material">

                        <InputField
                            inputProps={{
                                id: key,
                                name: key,
                                className: "form-input",
                                type,
                                value: isCurrencyKey ? HELPER.addCurrencyFormatting(formValues[field.key] ?? "") : formValues[field.key] ?? "",
                                maxLength,
                                disabled,
                                spellCheck:false,
                                onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
                                    if (key === "transaction_fee" && ((!/^\d$/.test(e.key) && !["Backspace", "Delete"].includes(e.key)) || (e.key === "e" || e.key === "." || e.key === "-" || e.key === "E"))) {
                                        e.preventDefault();
                                    }
                                }
                            }}
                          onChange={(e: any) => {
                            // const value =
                            //     field.key === 'transaction_fee' && COUNTRY_CODE === 'id'
                            //     ? HELPER.removeCurrencyFormattingId(e.target.value)
                            //     : e.target.value;
                            const finalValue = isCurrencyKey ? HELPER.removeCurrencyFormattingId(e.target.value) : e.target.value;

                            handleChange(field.key, finalValue);
                            }}

                            // onBlur = {(e: any) => {
                            //     handleBlurChange(field, e)
                            // }}
                        />
                        <label data-label={placeholder} className="form-label"></label>

                    </div>
                </fieldset>
                : (
                    <React.Fragment key={key}>
                        <ReactSelect
                            options={getFieldItemOptions(field)}
                            value={ formValues[field.key] || ""}
                            placeholder={placeholder}
                            handleChange={(e: any) => handleChange(field.key, e.target.value)}
                            fieldKey={key}
                            fieldSetClassName={classname}
                            isDisabled={disabled}
                        />
                    </React.Fragment>
                )
        );
    };

    const formFields: any = [
        { key: "insurance_partner", type: "text", label: `${translations.Insurance?.['PARTNER'] || translations.commonMsg?.loading}`, placeholder: `${translations.Insurance?.['PARTNER'] || translations.commonMsg?.loading}`},
        { key: "commision_to_oto_per", type: "text", label: `${translations.Insurance?.['OTO_COMMISION_RATE'] || translations.commonMsg?.loading}`, placeholder: `${translations.Insurance?.['OTO_COMMISION_RATE'] || translations.commonMsg?.loading}`},
        { key: "basic_premium_amount", type: "text", label: `${translations.Insurance?.['BASIC_PREMIUM'] || translations.commonMsg?.loading}`, placeholder: `${translations.Insurance?.['BASIC_PREMIUM'] || translations.commonMsg?.loading}`},
        { key: "total_addons_premium", type: "text", label: `${translations.Insurance?.['ADS_PREMIUM'] || translations.commonMsg?.loading}`, placeholder: `${translations.Insurance?.['ADS_PREMIUM'] || translations.commonMsg?.loading}`},
        { key: "gwp_amount", type: "text", label: `${translations.Insurance?.['GWP'] || translations.commonMsg?.loading}`, placeholder: `${translations.Insurance?.['GWP'] || translations.commonMsg?.loading}`},
        { key: "customer_discount", type: "text", label: `${translations.Insurance?.['Discount to Customer'] || translations.commonMsg?.loading}`, placeholder:`${translations.Insurance?.['Discount to Customer'] || translations.commonMsg?.loading}`},
        { key: "net_premium", type: "text", label: `${translations.Insurance?.['Net Premium'] || translations.commonMsg?.loading}`, placeholder: `${translations.Insurance?.['Net Premium'] || translations.commonMsg?.loading}`},
        { key: "admin_fee", type: "text", label: `${translations.Insurance?.['Admin Fee'] || translations.commonMsg?.loading}`, placeholder: `${translations.Insurance?.['Admin Fee'] || translations.commonMsg?.loading}` },
        { key: "transaction_fee", type: "text", label: `${translations.Insurance?.['Transaction Fee'] || translations.commonMsg?.loading} *`, placeholder: `${translations.Insurance?.['Transaction Fee'] || translations.commonMsg?.loading} *`, maxLength: 9 },
        { key: "total_invoice", type: "text", label: `${translations.Insurance?.['Total Invoice'] || translations.commonMsg?.loading}`, placeholder:  `${translations.Insurance?.['Total Invoice'] || translations.commonMsg?.loading}` },
        { key: "net_off_commision", type: "text", label: `${translations.Insurance?.['NET_OFF_COMMISION'] || translations.commonMsg?.loading}`, placeholder:  `${translations.Insurance?.['NET_OFF_COMMISION'] || translations.commonMsg?.loading}` },
        { key: "commision_vat", type: "text", label: `${translations.Insurance?.['COMMISION_VAT'] || translations.commonMsg?.loading}`, placeholder:  `${translations.Insurance?.['COMMISION_VAT'] || translations.commonMsg?.loading}` },
        { key: "final_commision", type: "text", label: `${translations.Insurance?.['TOTAL_COMMISSION'] || translations.commonMsg?.loading}`, placeholder:  `${translations.Insurance?.['TOTAL_COMMISSION'] || translations.commonMsg?.loading}` },
        { key: "oto_to_partner", type: "text", label: `${translations.Insurance?.['OTO_TO_PARTNER'] || translations.commonMsg?.loading}`, placeholder:  `${translations.Insurance?.['OTO_TO_PARTNER'] || translations.commonMsg?.loading}` },
        { key: "oto_point", type: "text", label: `${translations.Insurance?.['OTO_POINT'] || translations.commonMsg?.loading}`, placeholder:  `${translations.Insurance?.['OTO_POINT'] || translations.commonMsg?.loading}` },
        { key: "point_vat", type: "text", label: `${translations.Insurance?.['POINT_VAT'] || translations.commonMsg?.loading}`, placeholder:  `${translations.Insurance?.['POINT_VAT'] || translations.commonMsg?.loading}` },
        { key: "final_point", type: "text", label: `${translations.Insurance?.['FINAL_POINT'] || translations.commonMsg?.loading}`, placeholder:  `${translations.Insurance?.['FINAL_POINT'] || translations.commonMsg?.loading}` },
        { key: "partner_to_oto", type: "text", label: `${translations.Insurance?.['PARTNER_TO_OTO'] || translations.commonMsg?.loading}`, placeholder:  `${translations.Insurance?.['PARTNER_TO_OTO'] || translations.commonMsg?.loading}` },
    ].map((field) => ({
        ...field,
        classname: "col-md-6",
        hidden: () => isFieldDisabled(field.key),
        show: shouldShowField(field.key),
    }));

    useEffect(() => {
        if (insuranceState.leadDetail.customer_api_call) {
            setLoading(true)
            let reqst: any = { lead_id: queryParams.id }
            let apiType = `fetchPartnerPaymentDetails`

            fetchLeadData({ ...reqst, apiType }).then((res: any) => {
                if (res && res.data && Object.keys(res.data).length) {
                   dispatch(updateLeadDetailsInStore({ ...insuranceState.leadDetail, ...res.data }))
                }
            }).finally(() => setLoading(false))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [insuranceState.leadDetail.customer_api_call])
 
    return (
        <div className="image-form-outer">
            <FullPageLoader show={loading} />
            <div className="image-tab-panel">
                <DocumentGallery formType={'insurance-premium-payment'} payment_from={'insurance-premium-payment'} />
            </div>
            <div className="form-tab-right-panel wrapperPosition inspolicyshared">
                <div className="lead-detail-from-outer">
                    <div className="lead-form-heading">
                        <h2>
                            {translations.Insurance?.['Insurer Partner Payment'] || translations.commonMsg?.loading}
                        </h2>
                    </div>
                    <div className="lead-form-filed">
                        <div className="row">
                            {formFields.map((field: any) => field.show && renderFieldComponent(field))}
                        </div>
                    </div>
                    <div className="btn-save-remarks m-xl-t">
                        {
                            // !HELPER.isUserHasAccessPage({ permissionID: (formType === 'soft-approval-received' ? ROLE_FEATURES['soft_approval_received'] : ROLE_FEATURES['insurance_policy_generated']), accessType: 'edit', assignUserId: insuranceState.leadDetail.assign_user_id })

                            HELPER.isUserHasUpdateAccess({ permissionID: (ROLE_FEATURES['insurer_partner_payment']), accessType: 'edit', leadDetails: insuranceState.leadDetail, pageSlug: formType }) && afterSaveBtn
                                // true && (!allStatus?.includes('6-9') || insuranceState?.leadDetail?.status_id === STATUS_SUB_STATUS['status']['insurer_partner_payment'])
                                ?
                                disableBtn ? 
                                <button type="button" className="btn-primary" disabled>{translations.Insurance?.['CALCULATE']}</button>
                                :
                                <button type="button" className="btn-primary" onClick={() => submitHandler()}>{translations.commonMsg?.['save'] || translations.commonMsg?.loading}</button>
                                :
                                <button type="button" className="btn-primary" disabled>{translations.commonMsg?.['save'] || translations.commonMsg?.loading}</button>

                        }
                        <LeadRemarksButton leadId={queryParams.id} remark_source={"insurer-partner-payment"} />
                    </div>
                </div>
            </div>
        </div>
    )
}